import React, { useEffect, useState, useContext, } from "react";
import { Button, Checkbox, ConfigProvider, Divider, InputNumber, List, Modal, Radio, Select, Tooltip } from "antd";
import { SendOutlined } from "@mui/icons-material";
import TextArea from "antd/es/input/TextArea";
import wati_logo_only from '../../../assets/wati_logo_only.png'
import { AuthContext } from "../../contexts/AuthContext";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SellIcon from "@mui/icons-material/Sell";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ImportExport from "@mui/icons-material/ImportExport";
import { CalendarOutlined, NumberOutlined, RedoOutlined, HeatMapOutlined } from '@ant-design/icons';

const WatiFinalViewModal = ({ allTemplateData, setAllTemplateData, handlCloseWatiFinalView, open_wati_chat, supplierSet, send_wati_general_message, priceValues, handleBestPriceChange, handlePercentageChange, handleDeliverycostChange, handleGivenPriceChange, handlePriceUpdate, handleQueryUpdate, setquerySet, setquerySetTable, handleWarrantyChange, handleWarrantyUpdate, approval_message_view, send_wati_approved_message, carLogoTypes }) => {

    const { authState } = useContext(AuthContext);

    const [chosenTemplateOutLocal, setChosenTemplateOutLocal] = useState(allTemplateData?.chosenTemplateOut);

    const [withOld, setwithOld] = useState(false);
    const changeWithOldChecked = e => {
        setwithOld(e.target.checked)
    };

    const [withTax, setwithTax] = useState(false);
    const changeWithTaxChecked = e => {
        setwithTax(e.target.checked)
    };

    const [EditContent, setEditContent] = useState(false);
    const changeEditContentChecked = e => {
        setEditContent(e.target.checked)
    };

    const [partsCondition, setpartsCondition] = useState('Used Genuine');
    const handlePartsConditionChange = (e) => {
        setpartsCondition(e.target.value);
    }
    const setReplyMessage = (message) => {
        setChosenTemplateOutLocal(message);
    }
    useEffect(() => {
        if (!EditContent) {
            const chosenTemplateID = allTemplateData?.chosenTemplateID;
            console.log(JSON.stringify(allTemplateData))
            var final_message = allTemplateData?.templates_temp?.find(e => e?.id == chosenTemplateID);
            final_message = final_message?.text;
            final_message = final_message?.replaceAll("{{query_id}}", allTemplateData?.record?.query_id).replaceAll("{{partname_value}}", allTemplateData?.record?.body_part).replaceAll("{{price_value}}", withOld ? priceValues?.[allTemplateData?.record?.query_id]?.price_given + ` (With Old)` : priceValues?.[allTemplateData?.record?.query_id]?.price_given).replaceAll("{{part_condition}}", partsCondition).replaceAll("{{warranty}}", priceValues?.[allTemplateData?.record?.query_id]?.warranty).replaceAll("{{operator.first_name}}", authState?.name).replaceAll("{{name}}", allTemplateData?.record?.customer_info?.name).replaceAll("{{make}}", allTemplateData?.record?.make).replaceAll("{{vat}}", withTax ? "(Inclusive of VAT 5%)" : "+ VAT (5%)");

            setChosenTemplateOutLocal(final_message);
        }
    }, [allTemplateData, partsCondition, priceValues, withOld, withTax]);

    //This one will load the incoming data on-mount of the modal
    //Also only when it is the price approval screen
    //otherwise this will not invoke
    useEffect(() => {
        if (approval_message_view && allTemplateData?.moredetails) {
            setwithOld(allTemplateData?.moredetails?.withOld);
            setwithTax(allTemplateData?.moredetails?.withTax);
            setEditContent(allTemplateData?.moredetails?.EditContent);
            setpartsCondition(allTemplateData?.moredetails?.partsCondition || 'Used Genuine');
            setChosenTemplateOutLocal(allTemplateData?.msg_text)
        }
    }, [allTemplateData]);


    const [wati_general_msg_send_loading, set_wati_general_msg_send_loading] = useState(false);


    const handleModalClose = () => {
        handlCloseWatiFinalView();
    }

    const handleSendWatiTemplate = async () => {
        if (approval_message_view) {
            set_wati_general_msg_send_loading(true)
            const res = await send_wati_approved_message({ id: allTemplateData?.approval_id, phone: allTemplateData?.record?.phone, user: allTemplateData?.record?.user, replyMessageId: allTemplateData?.chosenTemplateID }, chosenTemplateOutLocal);
            set_wati_general_msg_send_loading(false)
            if (res)
                handleModalClose()
        }
        else {
            const moredetails = { withOld, withTax, EditContent, partsCondition }
            set_wati_general_msg_send_loading(true)
            const res = await send_wati_general_message(allTemplateData?.record?.phone, chosenTemplateOutLocal, allTemplateData?.chosenTemplateID, allTemplateData?.record?.query_id, moredetails);
            set_wati_general_msg_send_loading(false)
            if (res)
                handleModalClose()
        }
    };
    const handleSupplierUpdateLocal = (selectedSupplier) => {
        setAllTemplateData(prev => ({
            ...prev,
            record: {
                ...prev.record,
                supplier: selectedSupplier
            }
        }))
        setquerySet(prev =>
            prev?.map(e =>
                e?.query_id == allTemplateData?.record?.query_id
                    ? { ...e, supplier: selectedSupplier }
                    : e
            )
        );
        setquerySetTable(prev =>
            prev?.map(e =>
                e?.query_id == allTemplateData?.record?.query_id
                    ? { ...e, supplier: selectedSupplier }
                    : e
            )
        );
    }
    return (
        <div>
            <Modal
                title={approval_message_view ? "Approving Price Message" : "Review message before sending"}
                centered
                open={allTemplateData?.finalViewOpen}
                onCancel={handleModalClose}
                zIndex={1001}
                maskClosable={false}
                width={1200}
                footer={
                    < div className="flex justify-between" >
                        <div className="italic ml-3" style={{ fontSize: "12px" }}>
                            *Make direct edits to the template at the last step
                        </div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Button: {
                                        defaultHoverColor: "#ffffff",
                                        defaultColor: "#ffffff",
                                        defaultHoverBg: "#3be368",
                                        defaultBg: "#31bd56",
                                    },
                                },
                            }}
                        >
                            <Button
                                variant="primary"
                                loading={wati_general_msg_send_loading}
                                onClick={handleSendWatiTemplate}
                            >
                                Send<SendOutlined />
                            </Button>
                        </ConfigProvider>
                    </div >
                }
            >
                <div className="border rounded m-2 p-3 drop-shadow">
                    <div className="row">

                        {/* First Column: Table with allTemplateData */}
                        <div
                            className="col-md-4"
                            style={{ overflowY: "auto" }}
                        >
                            <div className="border rounded m-2 p-2">
                                <div className="border rounded flex justify-center items-center" style={{ backgroundColor: "#808080", color: "white" }}>
                                    <span>Query</span>
                                    <span style={{ fontWeight: "700", backgroundColor: "black" }} className="border rounded ml-1 mr-1 pl-1 pr-1">&nbsp;{allTemplateData?.record?.query_id}&nbsp;</span>
                                    <span>Information</span>
                                </div>
                                <div className="rounded border p-2 mt-1 flex">
                                    <div className="flex items-center" style={{ fontWeight: "600" }}>
                                        <div>
                                            <Tooltip placement="left" title={allTemplateData?.record?.make}>
                                                <img style={{ width: "80px" }} src={carLogoTypes?.[allTemplateData?.record?.make?.toLowerCase()?.replaceAll(" ", "-")]?.logotype?.uri} alt={allTemplateData?.record?.make?.toLowerCase()?.replaceAll(" ", "-")} />
                                            </Tooltip>
                                            <div className="rounded border flex justify-center break-words pl-1 pr-1" style={{ fontSize: "16px", width: "80px" }}>{allTemplateData?.record?.model}</div>
                                        </div>

                                    </div>
                                    <Divider type="vertical" style={{ height: "unset" }} className="m-2" />
                                    <div style={{ width: "70%" }} className="items-center flex">
                                        <div style={{ width: "100%" }}>
                                            <div className="flex justify-between border rounded pl-1 pr-1">
                                                <div><CalendarOutlined />&nbsp;Year</div>
                                                <div style={{ fontWeight: "600" }}>{allTemplateData?.record?.year || (<span className="italic text-gray-700" style={{ fontWeight: "200" }}>Not added</span>)}</div>
                                            </div>
                                            <div className="flex justify-between border rounded pl-1 pr-1 mt-2">
                                                <div><NumberOutlined />&nbsp;VIN</div>
                                                <div style={{ fontWeight: "600" }}>{allTemplateData?.record?.chassis_no || (<span className="italic text-gray-700" style={{ fontWeight: "200" }}>Not added</span>)}</div>
                                            </div>
                                            <div className="flex justify-between border rounded pl-1 pr-1 mt-2">
                                                <div><RedoOutlined />&nbsp;Cylinders</div>
                                                <div style={{ fontWeight: "600" }}>{allTemplateData?.record?.cylinder || (<span className="italic text-gray-700" style={{ fontWeight: "200" }}>Not added</span>)}</div>
                                            </div>
                                            <div className="flex justify-between border rounded pl-1 pr-1 mt-2">
                                                <div><HeatMapOutlined />&nbsp;Region</div>
                                                <div style={{ fontWeight: "600" }}>{allTemplateData?.record?.region || (<span className="italic text-gray-700" style={{ fontWeight: "200" }}>Not added</span>)}</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="p-2 m-2 border rounded">
                                <div className="border rounded flex justify-center items-center" style={{ backgroundColor: "#808080", color: "white" }}>Parts Information
                                </div>
                                <div>
                                    <div className="mt-2 flex" style={{ width: "100%", height: "99px" }}>
                                        <List
                                            style={{ width: "100%", height: "100px", overflowY: "scroll" }}
                                            size="small"
                                            bordered
                                            dataSource={allTemplateData?.record?.body_part.split(",")}
                                            renderItem={(item, index) => <List.Item>{index + 1}. {item}</List.Item>}
                                        />

                                    </div>
                                </div>
                            </div>

                            <div className="p-2 m-2 border rounded">
                                <div className="border rounded flex justify-center items-center" style={{ backgroundColor: "#808080", color: "white" }}>Parts Condition
                                </div>
                                <div>
                                    <div className="p-1 flex justify-center">
                                        <div style={{ maxWidth: "155px" }}>
                                            <Radio.Group
                                                onChange={handlePartsConditionChange}
                                                value={partsCondition}
                                                options={[
                                                    { value: 'Used Genuine', label: 'Used Genuine' },
                                                    { value: 'Aftermarket New', label: 'Aftermarket New' },
                                                    { value: 'Genuine New', label: 'Genuine New' }
                                                ]}
                                            />
                                        </div>
                                        <div className="border rounded p-2">
                                            <Checkbox
                                                checked={withOld}
                                                onChange={changeWithOldChecked}>With Old Part</Checkbox>
                                            <Divider type="horizontal" className="mt-1 mb-1 p-0" />
                                            <Checkbox
                                                checked={withTax}
                                                onChange={changeWithTaxChecked}>Inclusive of Tax</Checkbox>
                                        </div>
                                    </div>
                                    <Divider type="horizontal" className="mt-2 mb-2" />
                                    <div className="flex justify-center">
                                        <InputNumber
                                            size="small"
                                            addonAfter={"Days"}
                                            addonBefore={"Warranty"}
                                            onChange={(e) => {
                                                handleWarrantyChange(allTemplateData?.record?.query_id, e);
                                                handleWarrantyUpdate(allTemplateData?.record?.query_id, e);
                                            }
                                            }
                                            value={priceValues?.[allTemplateData?.record?.query_id]?.["warranty"]}
                                            placeholder="Warranty in Days"
                                        />
                                    </div>
                                </div>
                            </div>


                        </div>

                        {/* Second Column: Textarea */}
                        <div className="col-md-4 border rounded p-2">
                            <div className="flex items-center justify-between">
                                <h5>Message Content</h5>
                                <div className="border rounded p-1 mb-1">
                                    <Tooltip placement="left" title={"Enable this to edit the content directly"}>
                                        <Checkbox
                                            checked={EditContent}
                                            onChange={changeEditContentChecked}>Edit the content directly</Checkbox>
                                    </Tooltip>
                                </div>
                            </div>
                            <Tooltip placement="rightTop" title={!EditContent ? "To edit the content directly, tick the box above" : null}>
                                <TextArea
                                    disabled={!EditContent}
                                    rows={21}
                                    placeholder="Type your message here..."
                                    value={chosenTemplateOutLocal}
                                    onChange={(e) => setReplyMessage(e.target.value)}
                                />
                            </Tooltip>
                        </div>

                        {/* Third Column: Another Table with allTemplateData */}
                        <div className="col-md-4">
                            <div className="border rounded m-2 p-2">
                                <div className="border rounded flex justify-center items-center" style={{ backgroundColor: "#808080", color: "white" }}>Customer Information</div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td><div className="ml-2" style={{ fontWeight: "550" }}>{allTemplateData?.record?.cus_name}</div></td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>:</td>
                                            <td className="flex items-center gap-1"><span className="ml-2" style={{ fontWeight: "550" }}>{allTemplateData?.record?.phone}</span><span className="cursor-pointer"><Tooltip title="Go to the WATI chat">
                                                <img id={`wati_chat_button_${allTemplateData?.record?.query_id}`} onClick={() => open_wati_chat(`wati_chat_button_${allTemplateData?.record?.query_id}`, allTemplateData?.record?.phone)} style={{ width: "15px" }} src={wati_logo_only} />
                                            </Tooltip></span></td>
                                        </tr>
                                        <tr>
                                            <td>Source</td>
                                            <td>:</td>
                                            <td><div className="ml-2" style={{ fontWeight: "550" }}>{allTemplateData?.record?.moredetails?.queryOrigin?.[0]?.label || "Unknown"}</div></td>
                                        </tr>
                                        {approval_message_view ? (<tr>
                                            <td>Handled By</td>
                                            <td>:</td>
                                            <td><div className="ml-2" style={{ fontWeight: "550" }}>{allTemplateData?.record?.user_name || "Unknown"}</div></td>
                                        </tr>) : null}

                                    </tbody>
                                </table>
                            </div>
                            <div className="border rounded m-2 p-2">
                                <div className="border rounded flex justify-center items-center mb-1" style={{ backgroundColor: "#808080", color: "white" }}>Supplier and Pricing</div>
                                <div className="m-3 drop-shadow" style={{ maxWidth: "300px", minWidth: "200px" }}>
                                    <div style={{ backgroundColor: "#f7f7f7", borderRadius: "8px" }} className="p-1.5 drop-shadow">
                                        <div>
                                            <Select
                                                showSearch
                                                size="small"
                                                allowClear
                                                style={{ width: "209px" }}
                                                placeholder="Select a Supplier"
                                                options={supplierSet.map((item) => (
                                                    { value: item.id, label: item.name, number: item.number }))}
                                                value={allTemplateData?.record?.supplier ? parseInt(allTemplateData?.record?.supplier) : null}
                                                onChange={(e) => {
                                                    handleSupplierUpdateLocal(e);
                                                    handleQueryUpdate(e, true, "", false, "", false, "", false, allTemplateData?.record?.query_id, "", "", "", false, false);
                                                }
                                                }
                                                filterOption={(input, option) =>
                                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                                    String(option.value).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                                    String(option.number).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                            </Select>
                                        </div>
                                        <div className="pt-1 pl-1" style={{ fontSize: "10px", fontWeight: "540" }}>
                                            Pricing Details
                                        </div>
                                        <div className="border drop-shadow rounded p-1" style={{ backgroundColor: "#fbfbfb" }}>
                                            <div>
                                                <div style={{ fontSize: "10px" }}>BPrice</div>
                                                <InputNumber
                                                    style={{ width: "100%" }}
                                                    addonBefore={"AED"}
                                                    size="small"
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    onChange={(e) =>
                                                        handleBestPriceChange(allTemplateData?.record?.query_id, e)
                                                    }
                                                    onBlur={(e) => handlePriceUpdate(allTemplateData?.record?.query_id)}
                                                    value={priceValues?.[allTemplateData?.record?.query_id]?.["best_price_received"] || 0}
                                                    placeholder="Buying Price"
                                                />
                                            </div>
                                            <div >
                                                <Divider className="mt-1.5 mb-1.5" style={{ backgroundColor: "black" }} />
                                            </div>
                                            <div>
                                                <div style={{ fontSize: "10px" }}>Margin Percentage</div>
                                                <InputNumber
                                                    style={{ width: "100%" }}
                                                    size="small"
                                                    addonBefore={priceValues?.[allTemplateData?.record?.query_id]?.["price_percentage"] == 0 ? <ImportExport /> : priceValues?.[allTemplateData?.record?.query_id]?.["price_percentage"] > 0 ? <ArrowUpwardIcon style={{ color: "green" }} /> : <ArrowDownwardIcon style={{ color: "red" }} />}
                                                    addonAfter={"%"}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    onChange={(e) =>
                                                        handlePercentageChange(allTemplateData?.record?.query_id, e)
                                                    }
                                                    onBlur={(e) => handlePriceUpdate(allTemplateData?.record?.query_id)}
                                                    value={priceValues?.[allTemplateData?.record?.query_id]?.["price_percentage"] || 0}
                                                    placeholder="Margin Percentage"
                                                />
                                            </div>
                                            <div>
                                                <div style={{ fontSize: "10px" }}>Delivery Charge</div>
                                                <InputNumber
                                                    style={{ width: "100%" }}
                                                    size="small"
                                                    addonBefore={<LocalShippingIcon />}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    onChange={(e) => handleDeliverycostChange(allTemplateData?.record?.query_id, e)}
                                                    onBlur={(e) => handlePriceUpdate(allTemplateData?.record?.query_id)}
                                                    value={priceValues?.[allTemplateData?.record?.query_id]?.["delivery_cost"]?.["DeliveryCost"]}


                                                    placeholder="Delivery Cost"
                                                />
                                            </div>
                                            <div>
                                                <Divider className="mt-1.5 mb-1.5" style={{ backgroundColor: "black", }} />
                                            </div>
                                            <div>
                                                <div style={{ fontSize: "10px" }}>Final Price</div>
                                                <InputNumber
                                                    id={"price_given" + allTemplateData?.record?.query_id}
                                                    style={{ width: "100%", fontWeight: "700" }}
                                                    size="small"
                                                    addonBefore={<SellIcon />}
                                                    onChange={(e) =>
                                                        handleGivenPriceChange(allTemplateData?.record?.query_id, e)
                                                    }
                                                    onBlur={(e) => handlePriceUpdate(allTemplateData?.record?.query_id)}
                                                    value={priceValues?.[allTemplateData?.record?.query_id]?.["price_given"]}
                                                    placeholder="Price Given"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </Modal >
        </div>
    );
}

export default WatiFinalViewModal;